import { gql } from "@apollo/client";

export const GET_CREDIT_NOTES_COUNT = gql`
  {
    creditNotesCount
  }
`;